<template>
  <div>
    <main-layout>
      <v-container>
        <div
          class="mt-4"
          style="background-color: #ebf5ff; border-radius: 10px; height: 700px; display: flex"
        >
          <v-layout>
            <v-flex xs12 sm7 class="d-flex justify-center align-center">
              <v-img
                src="/static/img/assets/ttb-profile.png"
                max-width="400px"
                width="100%"
                contain
              ></v-img>
            </v-flex>
            <v-flex xs12 sm5 style="display: flex; justify-content: center; align-items: center">
              <div class="text-xs-center black--text" style="font-size: 20px">
                <div class="mb-4" style="display: flex; justify-content: center">
                  <v-img
                    src="/static/img/assets/ttb_logo.png"
                    max-width="100px"
                    width="100%"
                    contain
                  ></v-img>
                </div>
                <div style="display: flex; justify-content: center" class="font-weight-bold mb-4">
                  <span style="color: #002d63" class="mr-1">Welcome to</span>
                  <span style="color: #0050f0">t</span>
                  <span style="color: #f58a1f">t</span>
                  <span style="color: #002d63">b Bank</span>
                </div>
                <v-layout row wrap>
                  <v-flex xs6>
                    <v-btn
                      :loading="saveloading"
                      :disabled="checkinstatus"
                      class="ticket2profilebtn"
                      color="primary"
                      large
                      @click="onCheckinCheckout('check-in')"
                    >
                      <div>
                        <div>
                          <img
                            :style="checkinstatus ? '   filter: opacity(0.5)' : ''"
                            width="30px"
                            src="/static/img/assets/ticket2/icon-login-white.png"
                          />
                        </div>
                        <div :class="checkinstatus ? 'grey--text' : 'white--text'">Check-in</div>
                      </div>
                    </v-btn>
                  </v-flex>
                  <v-flex xs6>
                    <v-btn
                      :loading="saveloading"
                      :disabled="!checkinstatus"
                      class="ticket2profilebtn"
                      color="primary"
                      :class="!checkinstatus ? 'grey--text' : 'white--text'"
                      large
                      @click="onCheckinCheckout('check-out')"
                    >
                      <div>
                        <div>
                          <img
                            :style="!checkinstatus ? 'filter: opacity(0.5)' : ''"
                            width="30px"
                            src="/static/img/assets/ticket2/icon-logout-white.png"
                          />
                        </div>
                        <div :class="!checkinstatus ? 'grey--text' : 'white--text'">Check-out</div>
                      </div>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </div>
            </v-flex>
            <!-- <v-flex xs3 class="py-4 pl-4">
              <div style="background-color: #e1e1e1; border-radius: 10px">
                <div class="pa-2">
                  <div>
                    <div style="font-weight: 500" class="text-xs-right">Work log</div>
                    <div v-if="logloading" style="height: 400px; overflow: auto">
                      <scale-loader class="mt-5" :loading="true" :color="'grey'"></scale-loader>
                    </div>
                    <div v-else style="height: 400px; overflow: auto">
                      <div v-for="(log, k) in logdata" :key="k" class="my-2">
                        <div style="font-size: 13px">
                          คุณได้ทำการ<span
                            v-if="log.actions == 'check-in'"
                            style="color: #e5917e; font-weight: bold"
                          >
                            เข้าสู่ระบบ
                          </span>
                          <span v-else style="color: grey; font-weight: bold"> ออกจากระบบ </span>
                          วันที่
                          {{ log.timestamp | DateFormat('DD/MM/YYYY เวลา HH:mmน.') }}
                        </div>
                        <v-divider></v-divider>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </v-flex> -->
          </v-layout>
        </div>
      </v-container>
    </main-layout>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      logloading: false,
      saveloading: false,
      logdata: []
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    checkinstatus() {
      if (this.logdata && this.logdata.length && this.logdata[0].actions == 'check-in') {
        return true
      } else return false
    }
  },
  mounted() {
    this.getCheckinCheckoutLog()
  },
  methods: {
    getCheckinCheckoutLog() {
      const vm = this
      return new Promise((resolve, reject) => {
        const data = {
          pageid: vm.selectedBot.pageid,
          adminid: vm.$store.state.userid,
          limit: 15,
          offset: 0
        }
        vm.logloading = true
        api.ticket2CommonCheckinCheckoutLog(data, (err, response) => {
          if (err) {
            console.error(err)
            reject()
            return
          }

          vm.logloading = false
          vm.logdata = response.data
          if (
            vm.$store.state.pingLoginTimer === null &&
            response &&
            response.data &&
            response.data[0] &&
            response.data[0].actions === 'check-in'
          ) {
            vm.$store.dispatch('loadUpdatePingLogin')
          }
          resolve()
        })
      })
    },
    onCheckinCheckout(actions) {
      const vm = this
      const data = {
        adminId: vm.$store.state.userid,
        pageid: vm.selectedBot.pageid,
        actions // check-in หรือ check-out
      }
      const title = `${vm.$t('do_you_want')} ${actions} ?`
      vm.$swal
        .fire({
          text: title,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          showCancelButton: true
        })
        .then((result) => {
          if (result.value) {
            vm.saveloading = true
            api.ticket2CommonCheckinCheckout(data, async (err, response) => {
              if (err) {
                console.error(err)
                return
              }

              if (response && response.responsecode === 200) {
                if (actions === 'check-in') {
                  vm.$store.dispatch('loadUpdatePingLogin')
                  vm.$store.commit('SET_CHECK_IN', true)
                } else {
                  clearInterval(vm.$store.state.pingLoginTimer)
                  vm.$store.commit('SET_CHECK_IN', false)
                }

                await vm.getCheckinCheckoutLog()
                vm.saveloading = false
                vm.$swal.fire({
                  text: actions + ' สำเร็จ',
                  type: 'success'
                })
              } else if (response && response.responsecode === 204 && response.reason) {
                vm.saveloading = false
                await vm.getCheckinCheckoutLog()
                vm.$swal.fire({
                  text: response.reason,
                  type: 'error'
                })
              }
            })
          }
        })
    }
  }
}
</script>

<style lang="scss">
.ticket2profilebtn {
  border-radius: 15px !important;
  width: 100px !important;
  height: 94px !important;
  font-size: 14px !important;
  text-transform: none !important;

  color: grey !important;

  line-height: 21px !important;
  margin-top: 10px !important;
  //   display: block !important;
}
</style>



// WEBPACK FOOTER //
// src/features/ttb/Profile/index.vue